"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var dealerDetailsStyles_1 = require("./dealerDetailsStyles");
var ContentLine_1 = require("../components/contentLine/ContentLine");
var DealerDetails = function (_a) {
    var name = _a.name, streetName = _a.streetName, city = _a.city, postCode = _a.postCode;
    var style = dealerDetailsStyles_1.default();
    var _b = core_1.useTheme().checkoutLite.summary, hideDealerCity = _b.hideDealerCity, hideDealerPostcode = _b.hideDealerPostcode;
    return (<core_1.Box data-test="summary:container:dealer_details" className={style.wrapper}>
      <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1" className={style.title}>
            <Translation_1.default className={style.titleContent} id="trans__checkout__confirmation_page__summary__dealer_title"/>
          </core_1.Typography>} dataTest="summary:dealer_details:title"/>
      <ContentLine_1.default mainContent={<core_1.Typography className={style.elementContent} variant="subtitle1">
            {name}
          </core_1.Typography>} dataTest="summary:dealer_details:name" className={style.element}/>
      <ContentLine_1.default mainContent={<core_1.Typography className={style.elementContent} variant="subtitle1">
            {streetName}
          </core_1.Typography>} dataTest="summary:dealer_details:street_name" className={style.element}/>
      {!hideDealerCity && (<ContentLine_1.default mainContent={<core_1.Typography className={style.elementContent} variant="subtitle1">
              {city}
            </core_1.Typography>} dataTest="summary:dealer_details:city" className={style.element}/>)}
      {!hideDealerPostcode && postCode !== '0' && (<ContentLine_1.default mainContent={<core_1.Typography className={style.elementContent} variant="subtitle1">
              {postCode}
            </core_1.Typography>} dataTest="summary:dealer_details:post_code" className={style.element}/>)}
    </core_1.Box>);
};
exports.default = DealerDetails;
